import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '../button/Button';
import GlobalToolTip from '../tooltips/GlobalToolTip';
import { H2 } from '../containers/Headers';
import Icon from '../icon/Icon';

import { addressTypes } from '../../types/address';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const AddressCard = ({
  id,
  name,
  attention,
  careOf,
  addressLine1,
  addressLine2,
  city,
  state,
  zipCode,
  postal,
  country,
  isSelected,
  onClick,
  isLocked,
  isCheckout,
  handleEdit,
  phoneNumber,
  shopSuiteFloor,
  districtName
}) => {
  const handleEditClick = e => {
    e.stopPropagation();
    handleEdit({ id });
  };
  return (
    <div
      className={classnames('card address-card bg-white ml3-lg mr2-lg mb4-sm pt5-sm pb5-sm prl4-sm', {
        highlighted: isSelected,
        isLocked: !isCheckout && isLocked
      })}
      onClick={onClick}
      data-desc='address__card_address'
    >
      <div className='adr d-md-b'>
        {isLocked && (
          <div data-desc='address__card_locked'>
            <GlobalToolTip
              icon='lock'
              className='lockedIcon'
              content={new TranslatedCopy({ id: 'addressBook.locked.tooltip' }).toString()}
            />
          </div>
        )}
        {!isLocked && isCheckout && (
          <Button useBareClass className='lockedIcon' onClick={handleEditClick}>
            <Icon name='edit' alt='Edit Address' />
          </Button>
        )}
        <div className='truncate'>
          <div>
            <H2 data-desc='address__card_name'>{name}</H2>
            {/* eslint-disable-next-line no-nested-ternary */}
            {careOf ? (
              <>
                <H2 data-desc='address__card_attention'>{attention}</H2>
                <H2 data-desc='address__card_attention'>{careOf}</H2>
              </>
            ) : attention ? (
              <H2 data-desc='address__card_attention'>{attention}</H2>
            ) : (
              <div>&nbsp;</div>
            )}
          </div>
        </div>
        {shopSuiteFloor && <div>{shopSuiteFloor}</div>}
        <div className='address-block mt1-sm light'>
          <div className='street-address light truncate' data-desc='address__card_address1'>
            {addressLine1}
          </div>
          {addressLine2 && (
            <div className='street-address light truncate' data-desc='address__card_address2'>
              {addressLine2}
            </div>
          )}
          {districtName && <div>{districtName}</div>}
          <div className='truncate city-state-postal'>
            <span className='locality inline' data-desc='address__card_city'>
              {`${city}, `}
            </span>
            <span className='region inline' data-desc='address__card_state'>
              {`${state} `}
            </span>
            <span className='postal-code inline' data-desc='address__card_zipCode'>
              {zipCode || postal}
            </span>
          </div>
        </div>
        <div>
          <div className='light' data-desc='address_card_country_phone_number'>
            {country} {phoneNumber}
          </div>
        </div>
      </div>
    </div>
  );
};

AddressCard.defaultProps = {
  isCheckout: false,
  isLocked: false,
  isSelected: false,
  onClick: undefined
};

AddressCard.propTypes = {
  isCheckout: PropTypes.bool,
  isLocked: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  ...addressTypes
};

export default AddressCard;
